export function createLocal (index) {
    return {
        namespaced: true,
        state: {
            showBlockIds: JSON.parse(window.localStorage.getItem('__odr_showBlockIds') || null),
            flowEntry: JSON.parse(window.localStorage.getItem(`__odr_flowEntry:${index}`) || null),
            debugEmail: JSON.parse(window.localStorage.getItem(`__odr_debugEmail:${index}`) || null),
            debugIvrServer: JSON.parse(window.localStorage.getItem(`__odr_debugIvrServer:${index}`) || null),
            kangaroo: JSON.parse(window.localStorage.getItem('__odr_kangaroo') || null),
            chatAdditionalHeight: JSON.parse(window.localStorage.getItem(`__odr_chatAdditionalHeight:${index}`) || null),
        },
        mutations: {
            SET (state, { key, value }) {
                window.localStorage.setItem(`__odr_${key}:${index}`, JSON.stringify(value));
                state[key] = value;
            },
            SET_INDEXLESS (state, { key, value }) {
                window.localStorage.setItem(`__odr_${key}`, JSON.stringify(value));
                state[key] = value;
            },
        },
    };
}
